import React, { Component } from "react";
import ZPartner02Header from "./ZPartner02Header";
import ZPartner02Footer from "./ZPartner02Footer";

export class ZPartner02MemberSigninSuccess extends Component {
    static displayName = ZPartner02MemberSigninSuccess.name;

    constructor(props) {
        super(props);
        this.state = {

        };
    }

    componentDidMount() {
        const links = [
            "https://fonts.googleapis.com/css?family=Lato:300&text=1234567890,.-",
            "/css/style.css",
            "/css/style-sr.css"
        ];

        links.forEach(href => {
            const link = document.createElement("link");
            link.rel = "stylesheet";
            link.href = href;
            document.head.appendChild(link);
        });
    }

    render() {
        const query = new URLSearchParams(this.props.location.search);
        const param = decodeURIComponent(query.get("S") || "");

        return (
            <>
                <ZPartner02Header />

                <main id="main">
                    <section className="top-sr-bg bg-gray1">
                        <div className="container">
                            <div className="row justify-content-between">
                                <div className="col col-md-6">
                                    <h1 className="text-headpage text-white mb-0 pt-3 pb-3 ">
                                        <span className="d-none">Starbucks® Rewards</span>
                                        <img src="media/rewards/starbucks-rewards-logo-2.png" alt="Starbucks® Rewards" className="img-fluid" style={{ maxWidth: '158px' }} />
                                    </h1>
                                </div>
                            </div>
                        </div>
                    </section>
                    <section className="section-sign-in overflow-hidden pb-5">
                        <div className="container p-1 p-md-0">
                            <div className="row justify-content-center px-1 px-md-5">
                                <div className="col-md-6 mb-3 pt-3">
                                    <div className="py-5 p-4 box-sign-in">
                                        <div className="col-md-12 mb-4 pt-3 text-center">
                                            <h2 className="h5 mt-5 mb-2 fw-bold text-dark-212121">ผูกบัญชีสำเร็จ</h2>
                                            <p className="text-black">ไปที่หน้าร้านอาหารหรือหน้าสรุปคำสั่งซื้อจะมีเครื่องหมายถูกสีเขียวปรากฏอยู่ที่หลังคำว่า&nbsp;<strong>Starbucks<sup>®</sup> Rewards</strong></p>
                                            <h2 className="h5 mt-5 mb-2 fw-bold text-dark-212121">Success</h2>
                                            <p className="text-black">Green check mark will appear after&nbsp;<strong>Starbucks<sup>®</sup> Rewards</strong>&nbsp;on Restaurant and Order Summary page.</p>
                                            <div className="text-center mt-5">
                                                <a
                                                    href={param}
                                                    className="btn btn-primary rounded-pill px-5"
                                                    onClick={(e) => {
                                                        e.preventDefault();

                                                        if (!param) return;

                                                        // force open app scheme
                                                        window.location.href = param;
                                                    }}
                                                >
                                                    กลับไปยัง LINE MAN<br />
                                                    <small style={{ fontSize: '90%' }}>Back to LINE MAN</small>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/*<div style={{ marginTop: 24 }}>*/}
                        {/*    <small>*/}
                        {/*        Debug: Q = {query || "(empty)"} <br />*/}
                        {/*        switchBackUrl = {param || "(empty)"}*/}
                        {/*    </small>*/}
                        {/*</div>*/}
                    </section>
                </main>

                <ZPartner02Footer />
            </>
        );
    }
}
